<script>
import InputText from '@/components/InputText.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'FormContact',
  components: {
    InputText,
  },
  data() {
    return {
      message: {
        name: '',
        email: '',
        phone: '',
        content: '',
      },
      invalid: {
        name: '',
        email: '',
        phone: '',
        content: '',
      },
    };
  },
  computed: {
    ...mapGetters(['GET_SPINNER']),
  },
  methods: {
    ...mapActions(['CONTACT_SHEET']),
    formSubmit(e) {
      e.preventDefault();
      if (
        this.message.name &&
        this.message.email &&
        this.message.phone &&
        this.message.content &&
        this.invalid.name === '' &&
        this.invalid.email === '' &&
        this.invalid.phone === '' &&
        this.invalid.content === ''
      ) {
        this.message.created_at = new Date().toLocaleString('el-GR');
        this.CONTACT_SHEET(this.message);
        // this.$refs.contactForm.value.reset();
        this.message.name = '';
        this.message.email = '';
        this.message.phone = '';
        this.message.content = '';
        this.invalid.name = null;
        this.invalid.email = null;
        this.invalid.phone = null;
        this.invalid.content = null;
      }
    },
    checkMail() {
      const exp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      return exp.test(this.message.email);
    },
    checkPhone() {
      const exp = /^[0-9]+$/g;
      return exp.test(this.message.phone);
    },
  },
  watch: {
    // eslint-disable-next-line prettier/prettier
    'message.name': function () {
      if (this.message.name === '') {
        this.invalid.name = this.$t('pageContact.form.reqError');
      } else {
        this.invalid.name = '';
      }
    },
    // eslint-disable-next-line prettier/prettier
    'message.email': function () {
      if (this.message.email === '') {
        this.invalid.email = this.$t('pageContact.form.reqError');
      } else {
        this.checkMail()
          ? (this.invalid.email = '')
          : (this.invalid.email = this.$t('pageContact.form.mailError'));
      }
    },
    // eslint-disable-next-line prettier/prettier
    'message.phone': function () {
      if (this.message.phone === '') {
        this.invalid.phone = this.$t('pageContact.form.reqError');
      } else {
        this.checkPhone()
          ? (this.invalid.phone = '')
          : (this.invalid.phone = this.$t('pageContact.form.phoneError'));
      }
    },
    // eslint-disable-next-line prettier/prettier
    'message.content': function () {
      if (this.message.content === '') {
        this.invalid.content = this.$t('pageContact.form.reqError');
      } else {
        this.invalid.content = '';
      }
    },
  },
};
</script>

<template>
  <section id="form-section" class="form-section">
    <form @submit.prevent="formSubmit" ref="contactForm">
      <div class="input-text">
        <input-text
          v-model="message.name"
          :placeHolder="$t('pageContact.form.name')"
        >
          <span v-if="invalid.name">{{ invalid.name }}</span>
        </input-text>
        <input-text v-model="message.email" placeHolder="Email*">
          <span v-if="invalid.email">{{ invalid.email }}</span>
        </input-text>
        <input-text
          v-model="message.phone"
          :placeHolder="$t('pageContact.form.phone')"
        >
          <span v-if="invalid.phone">{{ invalid.phone }}</span>
        </input-text>
      </div>

      <textarea
        name="message"
        id="message"
        cols="30"
        rows="10"
        :placeHolder="$t('pageContact.form.message')"
        v-model="message.content"
      ></textarea>
      <transition name="slot-error" appear>
        <span class="error" v-if="invalid.content">{{ invalid.content }}</span>
      </transition>
      <button @click="formSubmit" class="submit-button">
        <span v-if="!GET_SPINNER" class="span-text">{{
          $t('pageContact.form.button')
        }}</span>
        <span v-if="GET_SPINNER">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle class="spinner_S1WN" cx="4" cy="12" r="3" />
            <circle class="spinner_S1WN spinner_Km9P" cx="12" cy="12" r="3" />
            <circle class="spinner_S1WN spinner_JApP" cx="20" cy="12" r="3" />
          </svg>
        </span>
      </button>
    </form>
  </section>
</template>

<style scoped lang="scss">
.slot-error-enter-active,
.slot-error-leave-active {
  transition: all 0.3s ease;
}

.slot-error-enter,
.slot-error-leave-to {
  transform: translateY(50%);
  opacity: 0;
}

form {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--size-5-4);

  @media (max-width: 900px) {
    gap: var(--size-6);
  }
}

.input-text {
  display: flex;
  gap: var(--size-5-4);

  @media (max-width: 900px) {
    flex-direction: column;
    gap: var(--size-6);
  }
}

textarea {
  width: 100%;
  padding: var(--size-5) 0 var(--size-5) var(--size-5);
  margin-bottom: 12px;

  font-family: var(--ff-roboto-sans);
  font-size: var(--fs-5-3);

  color: hsl(var(--clr-accent-100));
  background-color: hsl(var(--clr-primary-700));
  border: 1px solid hsl(var(--clr-accent-500));
  border-radius: 5px;
}

textarea::placeholder {
  font-family: var(--ff-roboto-sans);
  font-weight: 400;
  font-size: var(--fs-4-3);
  color: hsl(var(--clr-accent-100));
}

.error {
  position: absolute;
  bottom: 55px;
  left: 4px;
  z-index: 9;
  color: hsl(var(--clr-accent-500));
  font-size: var(--fs-4);

  @media (max-width: 900px) {
    bottom: 34px;
  }
}

button {
  display: block;

  width: 100%;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: var(--fs-16);
  text-transform: uppercase;
  letter-spacing: 1px;

  color: hsl(var(--clr-accent-600));
  background-color: hsl(var(--clr-primary-700));
  border: 1px solid hsl(var(--clr-accent-500));
  border-radius: 5px;

  transition: all 200ms ease-in-out;
}

.span-text {
  padding: 12px 0;
}

button:hover,
button:active {
  background-color: hsl(var(--clr-primary-900));
  transform: scale(1.01);
}

@media (max-width: 900px) {
  .form-section {
    width: 100%;
  }
}

// SPINNER

svg {
  width: auto;
  height: 36px;
  fill: hsl(var(--clr-accent-500));
}

.spinner_S1WN {
  animation: spinner_MGfb 0.8s linear infinite;
  animation-delay: -0.8s;
}
.spinner_Km9P {
  animation-delay: -0.65s;
}
.spinner_JApP {
  animation-delay: -0.5s;
}
@keyframes spinner_MGfb {
  93.75%,
  100% {
    opacity: 0.2;
  }
}
</style>
